import "./StripeCreateCardComponent.scss";

import {IOnInit} from "angular";
import {NewStripeCard} from "../../types/StripeTypes";
import {StripeService} from "../../service/StripeService";
import {StripeCardSummary} from "../../types/TfStripeTypes";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export const StripeCreateCard = "tfStripeCreateCard";

export function stripeCreateCard(parentDir: string) {
    return {
        templateUrl: `${parentDir}/create-card/StripeCreateCardComponent.html`,
        transclude: {
            footerSlot: "?stripeCreateCardFooter"
        },
        bindings: {
            onCreate: "&"
        },
        controllerAs: "ctrl",
        controller: StripeCreateCardsComponentController
    };
}

export class StripeCreateCardsComponentController implements IOnInit {

    public onCreate: Function;
    public card: NewStripeCard;

    public paymentProcessing = false;
    public processingError = false;
    public errorReason: string | null = null;

    private idempotency: Promise<string>;

    /** @ngInject */
    public constructor(private stripeService: StripeService, private currentUserService: CurrentUserService) {

    }

    public async $onInit() {
        this.requestIdempotencyToken();
    }

    private async requestIdempotencyToken() {
        this.idempotency = this.stripeService.idempotency();
    }

    public async submit() {
        const card = await this.createCard();
        this.onCreate({card});
    }

    private async createCard(): Promise<StripeCardSummary> {
        if (this.paymentProcessing) {
            return Promise.reject("In Progress");
        }
        try {
            const idempotency = await this.idempotency;
            this.paymentProcessing = true;
            this.processingError = false;
            const result = await this.stripeService.createCard(idempotency, this.card);
            if (result.isSuccess()) {
                this.currentUserService.refreshConfig();
                return result.card;
            } else {
                this.errorReason = result.reason;
                this.processingError = true;
                return Promise.reject(this.errorReason);
            }
        } catch (e) {
            this.errorReason = "Unable to process card";
            this.processingError = true;

            return Promise.reject(this.errorReason);
        } finally {
            this.paymentProcessing = false;
            this.requestIdempotencyToken();
        }
    }
}
